import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import Home from '../views/Home.vue';
import Introduction from '../views/Introduction.vue';
import Startup from '../views/Startup.vue';
import StartupInfo from '../views/StartupInfo.vue';
import Subscription from '../views/Subscription.vue';
import StartupInfoMatchingForm from '../views/StartupInfoMatchingForm.vue';
import Cooperator from '../views/Cooperator.vue';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/introduction',
    name: 'Introduction',
    component: Introduction,
  },
  {
    path: '/cooperator',
    name: 'Cooperator',
    component: Cooperator,
  },
  {
    path: '/startup',
    name: 'Startup',
    component: Startup,
  },
  {
    path: '/startup/info',
    name: 'StartupInfo',
    component: StartupInfo,
  },
  {
    path: '/subscription',
    name: 'Subscription',
    component: Subscription,
  },
  {
    path: '/startup/info/matchingForm/:companyName',
    name: 'StartupInfoMatchingForm',
    component: StartupInfoMatchingForm,
    props: true,
  },
];

const router = new VueRouter({
  routes,
});

export default router;
